import { ReactNode, useMemo } from 'react';
import { generate } from 'lean-qr';
import { toSvgDataURL } from 'lean-qr/extras/svg';

import { cx } from '@libs/classnames';
import { useClipboard } from '@libs/hooks/useClipboard';
import { FancyBadge } from '@ui/components/FancyBadge';

import styles from './StreamLinkShare.module.css';

const COPY_LABELS = {
  idle: 'Скопировать ссылку',
  copying: 'Скопировать ссылку',
  copied: 'Ссылка скопирована',
  error: 'Ошибка копирования',
};

export type Props = {
  className?: string;
  link: string;
  // низ правой колонки, например кнопка назад
  footer?: ReactNode;
};

export function StreamLinkShare({ className, link, footer }: Props) {
  const dataUrl = useMemo(
    () =>
      toSvgDataURL(generate(link), {
        on: '#000',
        off: '#fff',
        width: 160,
        height: 160,
        scale: 10,
        pad: 1,
      }),
    [link],
  );

  const { copy, copyState } = useClipboard();
  const canShare = typeof navigator.share === 'function';
  const onShare = () =>
    navigator.share({
      title: 'ChessOpen: видеоконтроль',
      text: 'Откройте ссылку на телефоне, чтобы начать трансляцию',
      url: link,
    });

  return (
    <div className={cx(styles.share, className)}>
      <img className={styles.share__qr} src={dataUrl} alt="QR-код" />
      <div className={styles.share__body}>
        <p className={styles.share__text}>Отсканируйте код телефоном или отправьте ссылку</p>
        <div className={styles.share__buttons}>
          <FancyBadge disabled={copyState === 'copying'} onClick={() => copy(link)}>
            {COPY_LABELS[copyState]}
          </FancyBadge>
          {canShare && <FancyBadge onClick={onShare}>Поделиться</FancyBadge>}
        </div>
        {footer && <div className={styles.share__footer}>{footer}</div>}
      </div>
    </div>
  );
}
